/**
 * Diese Komponente bindet dann das jeweilige Modul ein, übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React from 'react'
import { createStore, applyMiddleware } from 'redux'
import { Provider, useSelector } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from '@redux-devtools/extension'
import { UserSettings } from '@professocialApi/professocial-core-frontend-api'
import { getLicensePermissions, getTheme, getUser } from '../../../store/common/common.selectors'
import { Theme } from '@mui/material'

// Statistics
import ProfessocialStatistics from '@professocial/professocialStatistics/src/screens/ProfessocialStatistics'
import { statisticsRootReducer } from '@professocial/professocialStatistics/src/store/statisticsRoot.reducer'
import { statisticsRootSagas } from '@professocial/professocialStatistics/src/store/statisticsRoot.sagas'
import { getFacebookPage, getInstagramPage } from '../../../store/dashboard/dashboard.selector'
import { FacebookPage, InstagramPage } from '@3m5/sm_publish-frontend-api'
import { SocialNetworkLicensePermissions } from '@professocial/professocialTypes/types/commonTypes'

// Statistics
const sagaMiddleware = createSagaMiddleware()
const storeStatistics = createStore(
  statisticsRootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
  ),
)
sagaMiddleware.run(statisticsRootSagas)

const UserStatistics: React.FC = () => {
  const theme: Theme = useSelector(getTheme)
  const user: UserSettings | undefined = useSelector(getUser)
  const facebookPage: FacebookPage | undefined = useSelector(getFacebookPage)
  const instagramPage: InstagramPage | undefined = useSelector(getInstagramPage)
  const licensePermissions: SocialNetworkLicensePermissions = useSelector(getLicensePermissions)

  return (
    <>
      <Provider store={storeStatistics}>
        <ProfessocialStatistics
          statisticConfiguration={{
            theme,
            user,
            networkPage: {
              facebookPage: facebookPage,
              instagramPage: instagramPage,
            },
            licensePermissions: licensePermissions
          }}
        />
      </Provider>
    </>
  )
}
export default UserStatistics
